import { render, staticRenderFns } from "./PelleTab.vue?vue&type=template&id=57ae2e2e&scoped=true&"
import script from "./PelleTab.vue?vue&type=script&lang=js&"
export * from "./PelleTab.vue?vue&type=script&lang=js&"
import style0 from "./PelleTab.vue?vue&type=style&index=0&id=57ae2e2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ae2e2e",
  null
  
)

export default component.exports